import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import Stack from "@mui/material/Stack";
import {
  CustomTextField,
  CustomTitle,
  CustomText,
  CustomButton,
  CustomButton1,
} from "../../components/Custom";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PreviewIcon from "@mui/icons-material/Preview";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useFormik } from "formik";
import axios from "axios";
import BetterLife from "../../assets/images/betterLife.png";
import { AppContext } from "../../context";
import Service from "../../services";
import { DialogContent } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Axios } from "../../services/axios";

export default function Approvals() {
  const level = JSON.parse(sessionStorage.getItem("userDetails"))?.level;
  const API_URL = process.env.REACT_APP_API_URL;

  const appdata = useContext(AppContext);
  const [requestTypes, setRequestTypes] = appdata[4];
  const [loggedRequests, setLoggedRequests] = useState([]);

  //All requests for approvals
  const [requestsForApproval, setRequestsForApproval] = useState();

  //bulk action file
  const [requestFile, setRequestFile] = useState();

  const navigate = useNavigate();

  //Approve/Reject Requests Modal
  const [requestActions, setRequestActions] = useState(false);

  const handleOpenEditHG = () => setRequestActions(true);
  const handleCloseEditHG = () => {
    setUpdate(true);
    setRequestActions(false);
  };

  // Bulk Action Modal
  const [openBulkAction, setOpenBulkAction] = useState(false);

  const handleOpenBulkAction = () => setOpenBulkAction(true);
  const handleCloseBulkAction = () => {
    setOpenBulkAction(false);
  };

  //reject comment on request
  const [rejectComment, setRejectComment] = useState(false);
  const handleRejectComment = () => {
    setRejectComment(!rejectComment);
  };
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  const [selectedType, setSelectedType] = useState("");

  const [responseText, setResponseText] = useState("");

  const [errorText, setErrorText] = useState("");

  const [selectedRequestId, setSelectedRequestId] = useState();

  const [update, setUpdate] = useState(false);

  //Enhanced Table states

  //FETCH ALL LOGGED REQUESTS
  async function fetchLoggedRequests() {
    const response = await Service.getLoggedRequests();

    if (response.status == 200) {
      console.log(response);
      setLoggedRequests(response.data.data);
    }
  }
  useEffect(() => {
    setUpdate(false);
    fetchLoggedRequests();
  }, [update]);
  console.log(loggedRequests);

  //FETCH ALL REQUEST TYPES
  async function fetchRequestTypes() {
    const response = await Service.getRequestTypes();

    if (response.status === 200) {
      console.log(response);
      setRequestTypes(response.data.data);
    }
  }

  //FETCH ALL REQUESTS PENDING APPROVALS FOR BULK ACTION
  // async function fetchRequestsForApproval() {
  //   const response = await Service.getRequestsForApproval();

  //   if (response.status === 200) {
  //     console.log(response);
  //     setRequestsForApproval(response.data.data);
  //   }
  // }

  //FUNCTION TO DOWNLOAD REQUESTS FOR BULK ACTION
  async function fetchRequestsForApproval(requestType) {
    let idd = requestTypes.filter((item) => item.request_name == requestType);
    setLoading(true);

    const response = await Service.getRequestsForApproval(idd[0].request_id);
    console.log(response);
    // const responseMessage = response.message;
    if (response.status === 200 || response.status === 201) {
      setLoading(false);
      setSubmitted(true);

      navigate(0);
    } else {
      setLoading(false);
      setErrorMsg(true);
      console.log(response.message);
    }

    // console.log(responseData);
  }

  //HANDLE FILE IMPORT
  const changeHandler = (e) => {
    let fileUploaded = document.querySelector(`#${e.target.id}`);
    console.log(fileUploaded);
    let fileName = fileUploaded.value;
    let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    if (ext === "csv") {
      setRequestFile(e.target.files[0]);
    } else {
      alert("Invalid file format. Upload a .csv file");
    }
  };

  //File upload
  const [fileUploadSuccess, setFileUploadSuccess] = useState(false);
  const [fileUploadFail, setFileUploadFail] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  async function handleFileSubmit() {
    setFileUploadSuccess(false);
    setFileUploadFail(false);
    const formData = new FormData();
    formData.append("file", requestFile);

    formData.append(
      "staff_id",
      JSON.parse(sessionStorage.getItem("userDetails")).staff_id
    );
    let payload = formData;
    // console.log(payload);
    try {
      const response = await Axios.post(API_URL + "bulk_action", payload);

      if (response.status === 200 || response.status === 201) {
        setFileUploading(false);
        setFileUploadSuccess(true);
        setUpdate(true);
      }

      return response;
    } catch (err) {
      setFileUploading(false);
      setFileUploadFail(true);
      console.log(err.message);
    }
  }

  useEffect(() => {
    fetchRequestTypes();
  }, []);
  console.log(requestTypes);

  // useEffect(() => {
  //   setUpdate(false);
  //   try {
  //     axios.get(ID_URL + "/hg/hub/" + hubId).then((response) => {
  //       if (response.status == 200) {
  //         console.log(response);
  //         setHgList(response.data.data);
  //       }
  //       // console.log(typeof response.data.data[0].date_logged);
  //       // console.log(response.data.message);
  //     });
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // }, [update]);

  function createData(
    requestId,
    requestName,
    requestedBy,
    requestDate,
    status
  ) {
    return {
      requestId,
      requestName,
      requestedBy,
      requestDate,
      status,
    };
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const headCells = [
    {
      id: "requestId",
      numeric: false,
      disablePadding: true,
      label: "Request ID",
    },
    {
      id: "requestName",
      numeric: true,
      disablePadding: false,
      label: "Request Type",
    },

    {
      id: "requestedBy",
      numeric: true,
      disablePadding: false,
      label: "Requested By",
    },
    {
      id: "requestDate",
      numeric: true,
      disablePadding: false,
      label: "Request Date",
    },
    {
      id: "status",
      numeric: true,
      disablePadding: false,
      label: "Status",
    },
  ];

  function handleRowselected(id) {
    console.log(id);
    setSelectedRequestId(id);
    handleOpenEditHG();
  }

  console.log(selectedRequestId);

  function ApprovalModal() {
    const requestSelected = loggedRequests.filter(
      (hg) => hg.id === selectedRequestId
    )[0];
    console.log(requestSelected);

    const formik = useFormik({
      enableReinitialize: true,
      //   validationSchema: editUserValidationSchema,
      initialValues: { staff_comment: "" },
    });

    //REQUEST ACTIONS

    async function handleApprove(requestId) {
      let payload = {
        staff_id: JSON.parse(sessionStorage.getItem("userDetails")).staff_id,
        staff_comment: formik.values.staff_comment,
        id: requestId,
      };
      setErrorMsg(false);
      setSubmitted(false);
      setLoading(true);

      const response = await Service.approveRequest(payload);
      console.log(response);
      if (response.status === 200 || response.status === 201) {
        console.log(response);
        setLoading(false);
        setSubmitted(true);
        setResponseText(response.data.message);
        // setUpdate(true);
        window.setTimeout(function () {
          setSubmitted(false);
        }, 6000);
      } else if (response.status === 403) {
        console.log(response?.data, response, "response")
        let errorMessages = response.data?.data.map(item => {
          return item.data; // Assuming the message is in the 'data' field as per your example
        });

        // Ensure errorMessages is always treated as an array
        if (!Array.isArray(errorMessages)) {
          errorMessages = [errorMessages];
        }
        console.log(errorMessages, 'error messages')

        setErrorMessages(errorMessages);
        setErrorMsg(true);
        setLoading(false);

        // setInvalidRows(true);
      }
      else {
        setLoading(false);
        setResponseText(response.message);

        window.setTimeout(function () {
          setResponseText("");
        }, 8000);
        setErrorMsg(true);
      }
    }

    async function handleReject(requestId) {
      setRejectComment(false);
      let payload = {
        staff_id: JSON.parse(sessionStorage.getItem("userDetails")).staff_id,
        staff_comment: formik.values.staff_comment,
        id: requestId,
      };
      setErrorMsg(false);
      setSubmitted(false);
      setLoading(true);

      const response = await Service.rejectRequest(payload);
      console.log(response);
      if (response.status === 200) {
        console.log(response);
        setLoading(false);
        setSubmitted(true);
        setResponseText(response.data.message);
        // setUpdate(true);
        window.setTimeout(function () {
          setSubmitted(false);
        }, 8000);
      } else {
        setLoading(false);
        setResponseText(response.message);

        setErrorMsg(true);
      }
    }

    async function handleHalt(requestId) {
      let payload = {
        staff_id: JSON.parse(sessionStorage.getItem("userDetails")).staff_id,
        staff_comment: formik.values.staff_comment,
        id: requestId,
      };
      setErrorMsg(false);
      setSubmitted(false);
      setLoading(true);

      const response = await Service.haltRequest(payload);
      console.log(response);
      if (response.status === 200) {
        console.log(response);
        setLoading(false);
        setSubmitted(true);
        setResponseText(response.data.message);
        // setUpdate(true);
        window.setTimeout(function () {
          setSubmitted(false);
        }, 8000);
      } else {
        setLoading(false);
        setResponseText(response.message);
        setErrorMsg(true);
      }
    }

    async function handlePend(requestId) {
      let payload = {
        staff_id: JSON.parse(sessionStorage.getItem("userDetails")).staff_id,
        staff_comment: formik.values.staff_comment,
        id: requestId,
      };

      setErrorMsg(false);
      setSubmitted(false);
      setLoading(true);
      const response = await Service.pendRequest(payload);

      if (response.status === 200) {
        console.log(response);
        setLoading(false);
        setSubmitted(true);
        setResponseText(response.data.message);
        setUpdate(true);
        window.setTimeout(function () {
          setSubmitted(false);
        }, 8000);
      } else {
        setLoading(false);
        setResponseText(response.message);

        setErrorMsg(true);
      }
    }

    return (
      <div className="modal">
        <Modal
          open={requestActions}
          key={selectedRequestId}
          onClose={handleCloseEditHG}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #75748F",
              borderRadius: "10px",
              py: "32px",
              px: "40px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 800,
              bgcolor: "background.paper",
              //   overflow: "auto",
              overflowY: "auto",
              overflowX: "hidden",
              height: "700px",
            }}
          >
            <Stack
              direction="row"
              spacing={10}
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomTitle sx={{ fontSize: "20px" }}>
                {requestSelected && requestSelected.request_name}
              </CustomTitle>

              <IconButton aria-label="close" onClick={handleCloseEditHG}>
                <CancelOutlinedIcon />
              </IconButton>
            </Stack>

            <br />
            <Divider />
            { }
            <form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  border: 1,
                  borderRadius: 1,
                  p: 2,
                  mb: 2,
                }}
              >
                {requestSelected &&
                  requestSelected.columns.map((item, index) => (
                    <Box key={index}>
                      {" "}
                      <CustomText>{item.name}</CustomText>
                      <CustomTextField
                        type={item.isNumber ? "number" : "text"}
                        name={item.name}
                        id={item.name}
                        value={item.value}
                        // onChange={formik.handleChange}
                        // placeholder="Enter member ID"
                        sx={{ mb: 2 }}
                        fullWidth
                      />
                      <br />
                    </Box>
                  ))}
                <CustomText> Issue Description</CustomText>
                <CustomTextField
                  type="text"
                  multiline
                  name="issueDescription"
                  id="issueDescription"
                  value={requestSelected.comment}
                  sx={{ mb: 2 }}
                  disabled={
                    JSON.parse(sessionStorage.getItem("userDetails")).level !==
                    0 || requestSelected.status > 0
                  }
                  fullWidth
                />
              </Box>
              {requestSelected &&
                ((level === 1 && requestSelected.status < 5) ||
                  (level === 2 &&
                    requestSelected.status >= 4 &&
                    requestSelected.status < 9) ||
                  (level === 3 && requestSelected.status > 7)) ? (
                <>
                  <Box
                    sx={{
                      // position: "relative",
                      // left: "37%",
                      textAlign: "center",
                    }}
                  >
                    <CustomButton
                      onClick={() => handleApprove(requestSelected.id)}
                      variant="contained"
                      disabled={
                        requestSelected.status === 1 ||
                        // requestSelected.status === 4 ||
                        requestSelected.status === 5 ||
                        requestSelected.status === 9 ||
                        loading
                      }
                      sx={{
                        py: 2,
                        px: 4,
                        m: 2,
                        background: "#58CC02",
                      }}
                    >
                      Approve
                    </CustomButton>
                    <CustomButton
                      onClick={handleRejectComment}
                      variant="contained"
                      disabled={
                        requestSelected.status === 2 ||
                        requestSelected.status === 6 ||
                        requestSelected.status === 10 ||
                        loading
                      }
                      sx={{
                        py: 2,
                        px: 4,
                        m: 2,
                        background: "#58CC02",
                      }}
                    >
                      Reject
                    </CustomButton>
                    <CustomButton
                      onClick={() => handlePend(requestSelected.id)}
                      variant="contained"
                      disabled={
                        requestSelected.status === 0 ||
                        requestSelected.status === 4 ||
                        requestSelected.status === 8 ||
                        loading
                      }
                      sx={{
                        py: 2,
                        px: 4,
                        m: 2,
                        background: "#58CC02",
                      }}
                    >
                      Pend
                    </CustomButton>{" "}
                    {!loading && submitted ? (
                      <h3 style={{ color: "green" }}>{responseText}</h3>
                    ) : null}{" "}
                    {!loading && errorMsg ? (
                      <Box
                        sx={{
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography variant="h6" component="h2" color="red">
                          Approval Failed Due To The Following reasons
                        </Typography>
                        <List
                          sx={{
                            textAlign: "center",
                            justifyContent: "center",
                            border: 1,
                            borderRadius: 1,
                            p: 3,
                            mb: 2,
                            overflowY: 'auto',
                            maxHeight: '400px',  // Optional: Adjust height as needed
                          }}>
                          {errorMessages.map((message, index) => (
                            <ListItem key={index}>
                              <ListItemText primary={message} />
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    ) : null}
                  </Box>
                </>
              ) : null}

              {rejectComment && (
                <Box
                  sx={{
                    border: "1px solid ",
                    borderRadius: "8px",
                    p: 3,
                    my: 4,
                    textAlign: "center",
                  }}
                >
                  <CustomText>Enter Reason for Rejection</CustomText>
                  <CustomTextField
                    name="staff_comment"
                    id="staff_comment"
                    value={formik.values.staff_comment}
                    onChange={formik.handleChange}
                    fullWidth
                    multiline
                  />
                  <CustomButton
                    onClick={() => handleReject(requestSelected.id)}
                    variant="outlined"
                    disabled={!rejectComment}
                    sx={{
                      py: 2,
                      px: 4,
                      m: 2,
                      color: "#58CC02",
                      borderColor: "#58CC02",
                    }}
                  >
                    Submit
                  </CustomButton>
                </Box>
              )}
            </form>
          </Box>
        </Modal>
      </div>
    );
  }

  function UsersEnhancedTable() {
    const [inputtedID, setInputtedID] = useState("");
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("status");
    const [selected, setSelected] = useState([]);
    const [dense, setDense] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const handleClearClick = () => {
      setInputtedID("");
    };
    //removes extra spaces
    function removeExtraSpaces(str) {
      return str
        .split(" ")
        .map((item) => item.trim())
        .filter((item) => item !== "")
        .join(" ");
    }

    const rows = loggedRequests
      ? loggedRequests
        .map((request) => {
          return createData(
            request.id,
            request.request_name,
            request.requested_by,
            request.date_created,
            request.status

            // user.id,
            // `${removeExtraSpaces(user.first_name)} ${removeExtraSpaces(
            //   user.last_name
            // )}`,

            //   "unresolved"
          );
        })
        .filter((item) => {
          if (inputtedID.trim().length > 0) {
            console.log(item.requestId);
            return item.requestId == inputtedID;
          } else if (selectedType.trim().length > 0) {
            return item.requestName
              .toLowerCase()
              .includes(selectedType.trim().toLowerCase());
          } else return item;
        })
      : [createData("-", "-", "-", "-", "-")];
    //search functionality
    //

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = rows.map((n) => n.id);
        setSelected(newSelecteds);

        return;
      }
      setSelected([]);
    };

    function EnhancedTableHead(props) {
      const {
        onSelectAllClick,
        order,
        orderBy,
        numSelected,
        rowCount,
        onRequestSort,
      } = props;
      const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
      };

      return (
        <TableHead sx={{ backgroundColor: "#F8DF3F" }}>
          <TableRow>
            {/* <TableCell padding="checkbox">
              <Checkbox
                color="primary"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{
                  "aria-label": "select all users",
                }}
              />
            </TableCell> */}
            <TableCell sx={{ font: "bold 15px feather" }}>Action</TableCell>
            {headCells.map((headCell) => (
              <TableCell
                key={headCell.id}
                align={headCell.numeric ? "center" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === headCell.id ? order : false}
                sx={{ font: "bold 15px feather" }}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      );
    }

    EnhancedTableHead.propTypes = {
      numSelected: PropTypes.number.isRequired,
      onRequestSort: PropTypes.func.isRequired,
      onSelectAllClick: PropTypes.func.isRequired,
      order: PropTypes.oneOf(["asc", "desc"]).isRequired,
      orderBy: PropTypes.string.isRequired,
      rowCount: PropTypes.number.isRequired,
    };

    const EnhancedTableToolbar = (props) => {
      const { numSelected } = props;

      return (
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            ...(numSelected > 0 && {
              bgcolor: (theme) =>
                alpha(
                  theme.palette.primary.main,
                  theme.palette.action.activatedOpacity
                ),
            }),
          }}
        >
          {/* {numSelected > 0 ? (
            <Typography
              sx={{ flex: "1 1 100%" }}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} selected
            </Typography>
          ) : ( */}
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            Requests
          </Typography>
          {/* )} */}

          {/* {numSelected > 0 ? (
            <Tooltip title="Delete">
              <IconButton onClick={() => deleteListOfUsers(selected)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Filter list">
              <IconButton>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          )} */}
        </Toolbar>
      );
    };

    EnhancedTableToolbar.propTypes = {
      numSelected: PropTypes.number.isRequired,
    };

    const handleClick = (event, name) => {
      const selectedIndex = selected.indexOf(name);
      let newSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, name);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }

      setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const isSelected = (email) => selected.indexOf(email) !== -1;
    const checkDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    return (
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            mb: 2,
            borderRadius: "10px",
            borderColor: "#75748F",
          }}
        >
          <CustomTextField
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            label="Filter by Request Type"
            select
            sx={{ m: 3, float: "left", width: "50%" }}
          >
            {requestTypes.map((request) => {
              return (
                <MenuItem key={request.request_id} value={request.request_name}>
                  {request.request_name}
                </MenuItem>
              );
            })}
          </CustomTextField>
          <CustomButton
            onClick={() => fetchRequestsForApproval(selectedType)}
            variant="contained"
            sx={{
              float: "right",
              py: 2,
              px: 5,
              m: 2,
              background: "#58CC02",
            }}
            disabled={selectedType.trim().length == 0 || rows.length == 0}
          >
            Download All
          </CustomButton>
          <CustomButton
            onClick={handleOpenBulkAction}
            variant="contained"
            sx={{
              float: "right",
              py: 2,
              px: 5,
              m: 2,
              background: "#58CC02",
            }}
          >
            Bulk Action
          </CustomButton>
          <Dialog
            open={openBulkAction}
            onClose={handleCloseBulkAction}
            fullWidth
          >
            <DialogTitle>Bulk Action</DialogTitle>{" "}
            <IconButton
              aria-label="close"
              onClick={handleCloseBulkAction}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              {" "}
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  border: 1,
                  borderRadius: 1,
                  p: 3,
                  my: 4,
                }}
              >
                <CustomText sx={{ mt: 4 }}>Upload Bulk Action File</CustomText>
                {/* Download <a href="#">Template</a> */}
                <Box
                  sx={{
                    border: 1,
                    borderStyle: "dashed",
                    borderRadius: 3,
                    p: 1,

                    textAlign: "center",
                  }}
                >
                  <Grid container sx={{ py: 2, px: 2 }}>
                    <Grid item xs={8} sx={{ py: 2 }}>
                      {requestFile && (
                        <CustomButton
                          sx={{
                            p: 1,
                            "&:hover": {
                              backgroundColor: "#fbf9f9",
                            },
                          }}
                        >
                          {" "}
                          <DeleteOutlineIcon
                            onClick={() => setRequestFile()}
                            sx={{ color: "#58CC02" }}
                          />
                        </CustomButton>
                      )}

                      <CustomButton
                        component="label"
                        sx={{
                          p: 2,
                          font: "16px bloggerSans",
                          background: "#58CC02",
                        }}
                      >
                        <input
                          type="file"
                          accept=".csv"
                          id={"requestLogFile"}
                          onChange={(e) => changeHandler(e)}
                          hidden
                        />
                        {requestFile ? `${requestFile.name}` : "Add File"}
                      </CustomButton>
                    </Grid>
                    <Grid item xs={4} sx={{ py: 2 }}>
                      <CustomButton1
                        sx={{
                          width: "10%",
                          py: "10px",
                          borderRadius: "0 5px 5px 0",
                        }}
                        onClick={handleFileSubmit}
                        disabled={!requestFile}
                      >
                        Upload
                      </CustomButton1>
                    </Grid>

                    {fileUploadSuccess && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          color: "green",
                        }}
                      >
                        <CustomTitle>File Uploaded Successfully</CustomTitle>
                      </Grid>
                    )}
                    {fileUploadFail && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          color: "red",
                        }}
                      >
                        <CustomTitle> Upload Failed</CustomTitle>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Box>
            </DialogContent>
          </Dialog>
          <FormControl
            sx={{
              mt: 2,
              width: "100%",
              diplay: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              px: "20px",
              mb: 1,
            }}
          >
            <CustomTextField
              sx={{
                width: "90%",
                py: "5px",
                borderRadius: "5px 0 0 5px",
              }}
              type="text"
              placeholder={"Search by Request ID"}
              value={inputtedID}
              onChange={(e) => setInputtedID(e.target.value)}
            />

            <CustomButton1
              sx={{ width: "10%", py: "10px", borderRadius: "0 5px 5px 0" }}
              onClick={handleClearClick}
            >
              Clear
            </CustomButton1>
          </FormControl>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {rows
                  .slice()
                  .sort(getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((rows, index) => {
                    const isItemSelected = isSelected(rows.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        // onClick={(event) => handleClick(event, rows.id)}
                        // role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={rows.id}
                        selected={isItemSelected}
                      >
                        {/* <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              "aria-labelledby": labelId,
                            }}
                          />
                        </TableCell> */}
                        <TableCell>
                          <IconButton
                            onClick={() => handleRowselected(rows.requestId)}
                          // disabled={loggedRequests.length < 1}
                          >
                            <ModeEditIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          {rows.requestId}
                        </TableCell>
                        <TableCell align="center">{rows.requestName}</TableCell>
                        <TableCell align="center">{rows.requestedBy}</TableCell>
                        <TableCell align="center">{rows.requestDate}</TableCell>
                        <TableCell align="center">
                          {rows.status === 0 && <p>Pending Zonal Approval</p>}
                          {rows.status === 1 && <p>Zonal Approved</p>}
                          {rows.status === 2 && <p>Zonal Rejected</p>}
                          {rows.status === 3 && <p>Zonal Halt</p>}
                          {rows.status === 4 && <p>Pending SHP Approval</p>}
                          {rows.status === 5 && <p>SHP Approved</p>}
                          {rows.status === 6 && <p>SHP Rejected</p>}
                          {rows.status === 7 && <p>SHP Halt</p>}
                          {rows.status === 8 && <p>Pending Tech Execution</p>}
                          {rows.status === 9 && <p>Tech Executed</p>}
                          {rows.status === 10 && <p>Tech Rejected</p>}
                          {rows.status === 11 && <p>Tech Halt</p>}
                          {rows.status === 12 && <p>Executed</p>}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <FormControlLabel
          control={<Switch checked={dense} onChange={handleChangeDense} />}
          label="Dense padding"
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        alignItems: "center",
        justifyContent: "center",
        border: 1,
        borderRadius: "10px",
        py: "40px",
        px: "28px",
        mb: "32px",
      }}
    >
      <Stack
        direction="row"
        spacing={10}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Stack direction="column" spacing={2}>
          <CustomTitle sx={{ fontSize: "20px" }}>Approvals</CustomTitle>
          {/* <CustomText>
            All aspects related to Red Flags on Input Distribution can be
            managed from this page
          </CustomText> */}
        </Stack>

        {/* <CustomButton1
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleOpenAddUser}
        >
          Create user
        </CustomButton1> */}
      </Stack>
      <br />

      <UsersEnhancedTable />

      {requestActions && selectedRequestId && <ApprovalModal />}
    </Box>
  );
}
